export const onEnterKey =
  (callback: () => void) => (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      callback();
    }
  };
